import React from "react"
import { Link } from "gatsby"

const SectionPrograms = () => (
  <section>
    <div className="wrap">
      <h2>Go to your program</h2>
      <div className="routes">
        <div className="route cjrx">
          <div className="r-head">
            <span className="r-name">CJR-X</span>
            <span className="r-sub">Starts January 1, 2028</span>
          </div>
          <div className="r-body">
            <div className="r-now">
              <b>What to do now</b>
              <p>
                Most hospitals will have upside and downside risk of 20%
                starting January 1, 2028. Learn how Avant-garde is helping
                leading health systems prepare.
              </p>
            </div>
            <div className="cta-row">
              <Link className="cta blue" to="/contact-us/">
                Speak with an Expert
              </Link>{" "}
              <Link className="cta ghost blue" to="/bundled-payments/cjr-x/">
                Learn More about CJR-X
              </Link>
            </div>
          </div>
        </div>
        <div className="route team">
          <div className="r-head">
            <span className="r-name">CMS TEAM</span>
            <span className="r-sub">Running now through 2030</span>
          </div>
          <div className="r-body">
            <div className="r-now">
              <b>What to do now</b>
              <p>
                Performance year 2 begins January 1, 2027, with two-sided risk
                for most hospitals. Know your exposure before then.
              </p>
            </div>
            <div className="cta-row">
              <Link className="cta" to="/contact-us/">
                Speak with an Expert
              </Link>{" "}
              <Link className="cta ghost" to="/cms-team/">
                Learn More about TEAM
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default SectionPrograms
